import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { CbicContentTypeMstService } from 'app/entities/cbic-content-type-mst/service/cbic-content-type-mst.service';
import { SessionStorageService } from 'ngx-webstorage';
import { ICbicDocMst } from 'app/entities/cbic-doc-mst/cbic-doc-mst.model';
import { CbicDocMstService } from 'app/entities/cbic-doc-mst/service/cbic-doc-mst.service';
import { DataUtils } from 'app/core/util/data-util.service';
import { UtilsService } from 'app/core/util/view-file.component';
import { CbicMenuMstService } from 'app/entities/cbic-menu-mst/service/cbic-menu-mst.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
@Component({
  selector: 'cbic-tenders-auctions',
  templateUrl: './tenders-auctions.component.html',
  styleUrls: ['./tenders-auctions.component.scss']

})
export class TendersAuctionsComponent implements OnInit {
  usedLanguage: any;
  color: any;
  contentTypeId: any;
  tenderData: any;
  tendersNotFound = false;
  tendersDataList: any;
  PdfDataList: any;
  firstPage: any;
  lastPage: any;
  nextPage: any;
  nextSize: any;
  prevPage: any;
  prevSize: any;
  searchText: any = '';

  page = 1;
  Pageing = 0;
  pageSize: any;
  count = 0;
  tableSize = 10;
  tableSizes = [10, 15, 20, 25, 50, 100, 200, 300, 400, 500]




  constructor(private sessionStorageService: SessionStorageService, private changeLnService: ChangeLanguageService, private contentMstService: CbicContentMstService
    , private cbicContentTypeMstService: CbicContentTypeMstService, private http: HttpClient,
    public menuService: CbicMenuMstService
    , private cbicDocMstService: CbicDocMstService, private dataUtils: DataUtils, private utils: UtilsService) { }

  isDataAvailable() {
    let dataAvailable = true;
    dataAvailable &&= this.tenderData != null && this.tenderData.length !== 0;
    return dataAvailable;
  };

  ngOnInit(): void {
    this.usedLanguage = this.changeLnService.getLanguage();
    this.getContentId();
    this.color = this.sessionStorageService.retrieve('colr');
  }

  getContentId(): void {
    this.cbicContentTypeMstService.getContentId('tender-action').subscribe(
      (fullBody) => {
        this.contentTypeId = fullBody.body?.id;
        this.getTenders(this.contentTypeId, 0, 10000000000);
        this.color = this.sessionStorageService.retrieve('colr');

      }
    )
  }

  getTenders(contentTypeId: any, Pageing: number, pageSize: number): void {
    const query: any = {};
    query['page'] = Pageing;
    query['size'] = pageSize;
    query['contentTypeId'] = contentTypeId;
    this.contentMstService.gettendersDataAll(query)
      .subscribe(
        (res: HttpResponse<ICbicContentMst[]>) => {
          this.tenderData = res.body
          if (this.tenderData.length === 0) {
            this.tendersNotFound = true
          } else {
            this.tendersNotFound = false;
            this.fetchListOfDoc(this.tenderData, contentTypeId);
          }
        });

  }




  fetchListOfDoc(tenderData: any, contentTypeId: any): void {
    if (this.tenderData) {
      this.tendersDataList = [];
      for (let i = 0; i < this.tenderData.length; i++) {
        this.tendersDataList[i] = Number(this.tenderData[i].id);
      }

    }

    this.cbicDocMstService.getDocList(this.tendersDataList, contentTypeId).subscribe(
      (data: HttpResponse<ICbicDocMst[]>) => {
        if (data.body) {
          this.PdfDataList = data.body;
        }

      })
  }



  ViewPdf(filePath: any) {
    this.utils.viewOpenning(filePath);
  }

  onTableDataChange(page: any) {
    // const request: any = {};
    this.Pageing = page.pageIndex.toString();
    this.pageSize = page.pageSize.toString();
    this.getTenders(this.contentTypeId, this.Pageing, this.pageSize);
  }

  ontableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    const request: any = {};
    this.Pageing = event.pageIndex.toString();
    request['size'] = event.pageSize.toString();
    this.getTenders(this.contentTypeId, this.Pageing, this.pageSize);
  }


  //reset the input
  onClick() {
    this.searchText = null;
  }

}